import React from 'react';
import { useSharedDataContext } from '../SharedDataContext';
import { CommaSeprator } from '../utility/utilityFunction';

const AddonSummaryCard = ({ isOnSummaryPage, payNow }) => {

    const { sharedData, sharedQuoteData } = useSharedDataContext();

    const policyenddate = new Date();
    policyenddate.setFullYear(policyenddate.getFullYear() + 1);
    // Define options for formatting the date
    const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    };

   // console.log({ sharedQuoteData });

    return (<>
        <div className="owner_detailbox2">
            <div className="">
                <div className="">
                    <img src={sharedQuoteData.Logo} className="img-fluid" alt="Future" />
                </div>
                <div className="text-center">
                    <h6>{sharedQuoteData.PlanName}</h6>
                </div>
            </div>
        </div>
        <div className="inquiry_num">
            <span>Enquiry#</span>
            <span>{sharedData.enquiryno}</span>
        </div>
        <div className="owner_detailbox2">
            <div className="policy_deta">
                <div className="policy_value">
                    <p className="">Policy Period</p>
                    <span>1 Year</span>
                </div>
                <div className="policy_value">
                    <p className="">Policy End Date</p>
                    <span>{sharedQuoteData?.PolicyEndDate?.split("-")?.reverse()?.join("-")}</span>
                </div>
                <div className="policy_value">
                    <p className="mb-1">Cover Value</p>
                    <span>₹{CommaSeprator(sharedData.SumInsured)}</span>
                </div>
            </div>
            <div className="">
                <div className="policy_value">
                    <p className="">Premium</p>
                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.Premium))}</span>
                </div>
                <div className="ms-3">
                    {sharedQuoteData.ThirdPartyAmt > 0 && <div className="policy_value">
                        <p className="">Third Party Liability Cover</p>
                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.ThirdPartyAmt))}</span>
                    </div>}
                    {sharedQuoteData.AmtPersonalBelongingsCover > 0 && <div className="policy_value">
                        <p className="">Lost & Stolen Cover</p>
                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtPersonalBelongingsCover))}</span>
                    </div>}
                    {sharedQuoteData.AmtEmergencyPetMinding > 0 && <div className="policy_value">
                        <p className="">Emergency Pet Minding Cover</p>
                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtEmergencyPetMinding))}</span>
                    </div>}
                    {sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall > 0 && <div className="policy_value">
                        <p className="">Veterinary Consultation On Call Cover</p>
                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall))}</span>
                    </div>}
                    {sharedQuoteData.AmtFuneralCostCover > 0 && <div className="policy_value">
                        <p className="">Funeral Cost Cover</p>
                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtFuneralCostCover))}</span>
                    </div>}
                    {sharedQuoteData.AmtTerminalDiesease > 0 && <div className="policy_value">
                        <p className="">Terminal Disease</p>
                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtTerminalDiesease))}</span>
                    </div>}
                    {sharedQuoteData.AmtLongTerm > 0 && <div className="policy_value">
                        <p className="">Long Term Cover</p>
                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtLongTerm))}</span>
                    </div>}
                </div>

                <div className="policy_value">
                    <p className="mb-1">+ GST (18%)</p>
                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.GST))}</span>
                </div>
            </div>
        </div>
        <div className="total_premium">
            <span>Total Premium</span>
            <span>₹{CommaSeprator(sharedQuoteData.TotalPremium)}</span>
        </div>
        {isOnSummaryPage && <button className="SMCBTN mb-3" id='payNowBtn' onClick={payNow}>Pay Now ₹{CommaSeprator(sharedData.TotalPremium)}</button>}
        {/* <div className="owner_detailbox2">
            <h6>Addons</h6>
            {sharedQuoteData.ThirdPartyAmt > 0 && <div className="policy_value">
                <p className="">Third Party Liability Cover</p>
                <span>₹{CommaSeprator(Math.round(sharedQuoteData.ThirdPartyAmt))}</span>
            </div>}
            {sharedQuoteData.AmtPersonalBelongingsCover > 0 && <div className="policy_value">
                <p className="">Lost & Stolen Cover</p>
                <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtPersonalBelongingsCover))}</span>
            </div>}
            {sharedQuoteData.AmtEmergencyPetMinding > 0 && <div className="policy_value">
                <p className="">Emergency Pet Minding Cover</p>
                <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtEmergencyPetMinding))}</span>
            </div>}
            {sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall > 0 && <div className="policy_value">
                <p className="">Vetenery Consultation On Call Cover</p>
                <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall))}</span>
            </div>}
            {sharedQuoteData.AmtFuneralCostCover > 0 && <div className="policy_value">
                <p className="">Funeral Cost Cover</p>
                <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtFuneralCostCover))}</span>
            </div>}
            {sharedQuoteData.AmtTerminalDiesease > 0 && <div className="policy_value">
                <p className="">Terminal Diesease</p>
                <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtTerminalDiesease))}</span>
            </div>}
            {sharedQuoteData.AmtLongTerm > 0 && <div className="policy_value">
                <p className="">Long Term Cover</p>
                <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtLongTerm))}</span>
            </div>}
        </div>*/}
    </>)
}
export default AddonSummaryCard;